/* eslint-disable @typescript-eslint/no-explicit-any */
const selectDemandasOcr = (state: any) => state.demandaOcr.list;

const demandaOcrSelectors = {
  selectDemandasOcr,
};

export { demandaOcrSelectors, selectDemandasOcr };
